"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Borra una cookie en el dominio y path indicados.
 *
 * @param {string} name   Nombre de la cookie.
 * @param {string} path   Ruta (p.ej. "/", "/app", ...). Default = "/".
 * @param {string} domain Dominio (p.ej. "example.com"). Default = el host actual.
 */
const deleteCookie = (name, path = "/", domain) => {
    let cookie = `${name}=; Max-Age=0; path=${path}; Expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    if (domain) {
        cookie += `; domain=${domain}`;
    }
    document.cookie = cookie;
};
exports.default = deleteCookie;
//# sourceMappingURL=index.js.map